/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { IMPORT_SECTION_ASSETS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGroupServiceMethods extends IPluginMethodMap {
  createGroup(args: any): any;
}

export class GroupService implements IAgentPlugin {
  readonly methods: IGroupServiceMethods;

  constructor() {
    this.methods = {
      createGroup: this.createGroup.bind(this),
    };
  }

  async createGroup(args: any) {
    console.log("Section Asset CSV Import ==> ", args);

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: IMPORT_SECTION_ASSETS,
          variables: {
            presentationId: args?.presentationId,
            sectionId: args?.sectionId,
            data: args?.validData || [],
          },
          fetchPolicy: "no-cache",
        });

        return res?.data?.importSectionAssetFeatureFromCsv;
      }
    } catch (err: any) {
      const displayMessage =
        err?.graphQLErrors &&
        Array.isArray(err.graphQLErrors) &&
        err.graphQLErrors.find((item: any) => item.extensions);

      if (displayMessage?.extensions?.display_message) {
        throw Error(displayMessage.extensions.display_message);
      }

      throw err;
    }
  }
}
